import { Routes } from '@angular/router';


export const AppRoutes: Routes = [

  // New Front Page
  {
    path: '',
    loadChildren: () => import('../app/newfrontpage/frontPage.module').then(m => m.FrontPageModule)
  },
  // Other components
  {
    path: 'register',
    loadChildren: () => import('../app/newfrontpage/register/shared/register.module').then(m => m.RegisterModule)

  },

  {
    path: 'session',
    loadChildren: () => import('./session/session.module').then(m => m.SessionModule),
  },
  {
    path: '**',
    redirectTo: 'session/not-found',
  },
];
